import { render } from "./expertJoin.vue?vue&type=template&id=19bbbb6e&scoped=true"
import script from "./expertJoin.vue?vue&type=script&lang=js"
export * from "./expertJoin.vue?vue&type=script&lang=js"

import "./expertJoin.vue?vue&type=style&index=0&id=19bbbb6e&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bbbb6e"]])

export default __exports__